<template>
  <div @click.self="closeModal" class="modalContainer">
    <div class="modalWrapper">
      <div @click="closeModal" class="close">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8.1161 6.6228L7.75908 6.97635L8.11437 7.33163L13.4572 12.6745L12.6745 13.4572L11.8466 12.6294L11.8449 12.6277L7.37718 8.11608L7.02364 7.75906L6.66835 8.11435L1.32551 13.4572L0.542786 12.6745L5.88563 7.33163L6.24062 6.97664L5.8842 6.62309L0.543158 1.32514L1.32551 0.542787L6.66835 5.88563L7.02334 6.24061L7.37689 5.88419L12.6748 0.543155L13.4572 1.32551L12.6294 2.15333L12.6277 2.15504L8.1161 6.6228ZM12.7648 13.5475C12.7649 13.5476 12.765 13.5478 12.7651 13.5479L12.7648 13.5475ZM0.452113 12.7651L0.452145 12.7651C0.452134 12.7651 0.452123 12.7651 0.452113 12.7651Z"
            fill="black"
            stroke="black"
          />
        </svg>
      </div>
      <h2>Update Order Time</h2>
      <p>
        Your order has not been placed as the time was pushed back. Please confirm the new time and resubmit your order
      </p>
      <p class="newTime">New Time: {{ getSuggestedTime }}</p>
      <button @click="updateTime">
        <div v-if="buttonLoader" class="loader buttonLoader"></div>
        <template v-else>CONFIRM</template>
      </button>
    </div>
  </div>
</template>

<script>
import modalMixins from '@/mixins/modalMixins.js'

export default {
  data() {
    return {
      buttonLoader: false,
    }
  },
  props: ['suggestedTime'],
  mixins: [modalMixins],
  computed: {
    getSuggestedTime() {
      return this.suggestedTime.split(' ')[0] + ' ' + this.suggestedTime.split(' ')[1]
    },
  },
  methods: {
    closeModal() {
      this.$emit('closeModal')
    },
    updateTime() {
      this.buttonLoader = true
      this.$emit('updateTime')
      this.$emit('confirmed')
    },
  },
}
</script>

<style src="../../../assets/css/Modals/StoreModals/NeedMoreTimeModal.css" scoped></style>
